<template>
  <div
    class="pilot-dialog"
    :class="{
      'pilot-dialog--minify': minify,
      'pilot-dialog--right': position === 'right',
      'pilot-dialog--left': position === 'left',
    }"
  >
    <div
      v-if="!noHeader"
      class="pilot-dialog__header"
    >
      <div class="pilot-dialog-header-left">
        <slot name="header-left" />
      </div>
      <div class="pilot-dialog-title">
        <span class="pilot-dialog-title__icon">
          <slot
            name="header-title-icon-left"
          />
        </span>
        <span class="pilot-dialog-title__text">{{ title }}</span>
        <span class="pilot-dialog-title__icon">
          <slot
            name="header-title-icon-right"
          />
        </span>
      </div>
      <div class="pilot-dialog-header-right">
        <slot name="header-right" />
      </div>
    </div>
    <div
      class="pilot-dialog__body"
      :class="{
        'pilot-dialog__body--scrollable': scrollable
      }"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PilotDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    minify: {
      type: Boolean,
      default: false
    },
    noHeader: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'center',
      validator (value) {
        return ['left', 'center', 'right'].includes(value)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import './style'

.pilot-dialog {
  height: 100%
  width: 100%
  position: fixed
  z-index: $pilot-player-z
  background-color: #2b2b2bf2
  transition: all .3s ease
  bottom: 0
  left: 0
  padding: 20px
  overflow: hidden
  display: flex
  flex-direction: column

  &--minify {
    height: 79px !important
    padding: 12px
  }

  &__header {
    position: relative
    padding: 5px
    height: 28px
    margin-bottom: 16px
    display: flex
    justify-content: space-between
    align-items: center

    .pilot-dialog-header-left {
      flex: 1
      display: flex
      justify-content: flex-start
      font-size: 24px
      color: $white
      cursor: pointer
    }

    .pilot-dialog-title {
      display: flex
      align-items: center

      &__text {
        font-size: 16px
        font-weight: 400
        color: $white
      }

      &__icon {
        font-size: 24px
        color: $white
        cursor: pointer
      }
    }

    .pilot-dialog-header-right{
      flex: 1
      display: flex
      justify-content: flex-end
      font-size: 24px
      color: $white
      cursor: pointer

      .isif-close {
        transform: scale(.8)
      }
    }
  }

  &__body {
    position: relative
    width: 100%
    height: 100%

    &--scrollable {
      overflow-y: auto
      scrollbars(5px, rgba(#ffffff, .5) , transparent)
    }
  }

  @media (min-width: 1024px) {
    height: 620px
    width: 420px
    border-radius: 8px
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    margin: 20px auto

    &--right {
      top: 0
      left: auto
      right: 0
      bottom: auto
      margin: 20px
    }

    &--left {
      top: 0
      left: 0
      right: auto
      bottom: auto
      margin: 20px
    }
  }
}

</style>
